// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lEqt","index":"styles_index__1cVww"};